import { render, staticRenderFns } from "./ServicioPersonalPage.vue?vue&type=template&id=72912122"
import script from "./ServicioPersonalPage.js?vue&type=script&lang=js&external"
export * from "./ServicioPersonalPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports